import { axiosV2 } from 'interceptors/axios';
import { Dispatch } from 'redux';

import { decryptResponse } from 'utils/token';
import { dispatchError } from 'utils/dispatchError';

import { Note } from 'types';

type CreateNoteProps = {
  note: Partial<Note>;
};

export const createNote =
  ({ note }: CreateNoteProps) =>
  async (dispatch: Dispatch) => {
    try {
      const { data } = await axiosV2.post(`/notes`, note);
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
